import type { TaskPriority } from './types';

/**
 * t168u: the fields every task form can send ("New task", "Create task from message", a building's Tasks tab,
 * the project board). The API's CreateTaskDto and the message ConvertDto are checked against this list at compile
 * time and in tests, so a field added to a form can't be rejected as "property x should not exist".
 */
export interface TaskCreateFields {
  title: string;
  description?: string;
  priority?: TaskPriority;
  assignee_ids?: string[];
  team_ids?: string[];
  location_id?: string | null;
  area_id?: string | null;
  due_date?: string | null;
  start_date?: string | null;
  milestone_id?: string | null;
  estimate_minutes?: number | null;
  budget_pence?: number | null;
  is_private?: boolean;
  due_time?: string | null;
  reminder_minutes?: number | null;
}
export const TASK_CREATE_FIELDS = ['title', 'description', 'priority', 'assignee_ids', 'team_ids', 'location_id', 'area_id', 'due_date',
  'start_date', 'milestone_id', 'estimate_minutes', 'budget_pence', 'is_private', 'due_time', 'reminder_minutes'] as const satisfies readonly (keyof TaskCreateFields)[];
// Every TaskCreateFields key is listed above.
const _allListed: Exclude<keyof TaskCreateFields, (typeof TASK_CREATE_FIELDS)[number]> extends never ? true : false = true;
void _allListed;

/** "Create task from message": the same fields, all optional, plus the project (null = No project). */
export type ConvertToTaskBody = Partial<TaskCreateFields> & { project_id?: string | null };

/** Field labels as the task forms show them, for turning API validation errors into "Budget is too large". */
export const TASK_FIELD_LABELS: Record<string, string> = {
  title: 'Title', description: 'Description', priority: 'Priority', assignee_ids: 'Assignees', team_ids: 'Assignees',
  location_id: 'Building', area_id: 'Area', due_date: 'Due date', start_date: 'Start date', milestone_id: 'Milestone',
  estimate_minutes: 'Estimate', budget_pence: 'Budget', due_time: 'Time', reminder_minutes: 'Reminder', project_id: 'Project',
};
